module.exports = __webpack_public_path__ + "static/media/005_Group.aee8fc4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/005_Group.png
// module id = 384
// module chunks = 0